module.exports = __webpack_public_path__ + "img/13.61a72462.jpg";